

//
const domnaHomeServiceProductForm = document.querySelector('#domna-home-service-product-form');

//
if (domnaHomeServiceProductForm !== null) {

    //
    const membershipNumber = domnaHomeServiceProductForm.dataset.membershipNumber;

    //
    const script = document.createElement('script');

    //
    script.src = `https://form.jotform.com/jsform/242354918474060?nrlaMembership=${encodeURIComponent(membershipNumber)}`;

    //
    script.async = true;

    //
    domnaHomeServiceProductForm.appendChild(script);

}